import { FC } from "react";
import { SimpleNav } from "~/components";
import { routes } from "~/constants";
import { trackActivate as track } from "~/OnboardingApp/events";
import { usePartner } from "~/OnboardingApp/hooks";
import { Body, Meta } from "./components";

export const ActivatePartnerPage: FC = () => {
  const { partnerSlugify } = usePartner();

  const previousRoute = partnerSlugify(
    routes.partnerOnboardingQuestionPhone,
  ) as typeof routes.partnerOnboardingQuestionPhone;

  return (
    <>
      <Meta />
      <SimpleNav
        handleClick={track.goToPreviousPage}
        previousRoute={previousRoute}
      />
      <Body />
    </>
  );
};
